import React from 'react'
import circle from '../../../assets/img/circulogris.png';
import { renderMultimedia, renderStory } from '../utils';
import Options from '../../../utils/components/Options/Options';
import { Translate } from '../../../language';
import { useDispatch } from 'react-redux';


const ChatCardMessage = ({ message, replyMenssage, isSelf, reportUser, srcImage, setReplyMenssage }) => {
    const options = [
        {
            text: Translate('reply', 'es'), onClick: (e) => {
                e.preventDefault(); e.stopPropagation();
                setReplyMenssage(message)
            }
        }
    ]

    const dispatch = useDispatch()
    return (
        <div key={message._id} className={`content-msg-data ${replyMenssage && replyMenssage._id === message._id ? 'replyMessage' : ''}  ${!isSelf ? 'startContent' : 'endContent'}`}>

            <div className="row">
                {true && <div className="row">
                    <div className={`column ${isSelf && 'endContent'}`}>
                        {!isSelf && (srcImage ? <img alt="img" className="navbar-img-icon" onError={(e) => e.target.src = circle} src={srcImage} /> :
                            <img alt="img" className="navbar-img-icon" src={circle} />)}
                        <div className={`${!isSelf ? 'message-other-user' : 'my-message'}`}>
                            <div className='column'>

                                <div className='message-name'>
                                    {
                                        message.senderUserId ? message.senderUserId.name : message.senderFranchiseId ? message.senderFranchiseId.socialReason :
                                            message.senderRepresentativeId ? message.senderRepresentativeId.userID.name : message.senderWarehouseId ? message.senderWarehouseId.name
                                                : message.senderAdminId ? message.senderAdminId.name : ""
                                    }
                                    {" "}
                                    {
                                        message.senderUserId ? message.senderUserId.lastname : message.senderRepresentativeId ? message.senderRepresentativeId.userID.lastname : ""
                                    }
                                    <div className='message-type'>
                                        {
                                             message.senderUserId ? "EcoAmigo" : message.senderFranchiseId ? "EcoTienda" :
                                             message.senderRepresentativeId ? "EcoMaster" : message.senderWarehouseId ? "EcoCeo"
                                                 : message.senderAdminId ? "Administrador" : ""
                                        }
                                        </div>
                                </div>
                                <div className="message-opt">
                                    <Options style={{
                                        position: "initial",
                                        width: "initial"
                                    }} options={options} />
                                </div>
                            </div>
                            <div className='row'>
                                {message.responseToMessageId && (
                                    <div className={`${!isSelf ? 'message-other-user message-other-user-response ' : 'my-message'}`}>

                                        <div>
                                            {
                                                message.responseToMessageId.senderUserId ? message.responseToMessageId.senderUserId.name : message.responseToMessageId.senderFranchiseId ? message.responseToMessageId.senderFranchiseId.socialReason :
                                                    message.responseToMessageId.senderRepresentativeId ? message.responseToMessageId.senderRepresentativeId.userID.name : message.responseToMessageId.senderWarehouseId ? message.responseToMessageId.senderWarehouseId.name
                                                        : message.responseToMessageId.enderAdminId ? message.responseToMessageId.senderAdminId.name : ""
                                            }
                                            {" "}
                                            {
                                                message.responseToMessageId.senderUserId ? message.responseToMessageId.senderUserId.lastname : message.responseToMessageId.senderRepresentativeId ? message.responseToMessageId.senderRepresentativeId.userID.lastname : ""
                                            }
                                        </div>

                                        {message.responseToMessageId.content}
                                    </div>)}
                                <div>
                                    {message.content}
                                </div>
                            </div>

                        </div>
                        {isSelf && (srcImage ? <img alt="img" className="navbar-img-icon" onError={(e) => e.target.src = circle} src={srcImage} /> :
                            <img alt="img" className="navbar-img-icon" src={circle} />)}
                    </div>

                </div>}
                {message.storyID &&
                    <>{renderStory(message.storyID)}</>
                }
                {message.multimedia && message.multimedia.length > 0 && message.multimedia.map((data, index) =>
                    <div key={index} className="multimedia-messages">{renderMultimedia(data)}</div>
                )}
                {message.link &&
                    <div className="multimedia-messages"><img alt="img" className='img-post-view' src={message.link} /></div>
                }
            </div>
        </div>
    )
}

export default ChatCardMessage
